<template>
  <div>
    <b-table
      responsive
      :items="items"
      :fields="fields"
    >
      <!-- A custom formatted question column -->
      <template #cell(question)="data">
        {{ data.value | summaryText }}
      </template>
      <template #cell(answer)="data">
        {{ data.value | summaryText }}
      </template>
      <!-- A custom formatted action column -->
      <template #cell(action)="data">
        <b-button
          v-if="$can('update', 'faqs')"
          variant="flat-success"
          size="sm"
          class="btn-icon rounded-circle"
          @click="editButtonClicked(data.item)"
        >
          <feather-icon icon="Edit2Icon" />
        </b-button>
        <b-button
          v-if="$can('delete', 'faqs')"
          variant="flat-danger"
          size="sm"
          class="btn-icon rounded-circle"
          @click="deleteButtonClicked(data.item)"
        >
          <feather-icon icon="TrashIcon" />
        </b-button>
      </template>
    </b-table>
    <div
      v-if="!items.length"
      class="d-flex justify-content-center align-items-center"
    >
      <h6 class="font-weight-bolder mb-0">
        {{ $t("There are no faqs to display") }}
      </h6>
    </div>
    <faqs-edit-modal
      :form="editForm"
      :additional-data="additionalData"
      @onHideModal="resetEditForm"
    />
  </div>
</template>

<script>
import { ListTable } from '../../../common/mixins/list'
import FaqsEditModal from '../edit/FaqsEditModal'

export default {
  name: 'FaqsList',
  components: { FaqsEditModal },
  mixins: [ListTable],
  data() {
    return {
      routeName: 'faqs',
    }
  },
}
</script>

<style scoped>

</style>
